import Button from '@/common/components/Button'
import { useGoBack } from '@/common/hooks/useGoBack'
import { flattedRoutes } from '@/common/Layout/Sidebar/routes'
import { useMineCompany } from '@/features/company/hooks/useMineCompany'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

interface NotFoundErrorMessageProps {
  fallback?: string
  buttonText?: string
  className?: string
  hideButton?: boolean;
}

export const NotFoundErrorMessage = ({ fallback, buttonText, className, hideButton }: NotFoundErrorMessageProps) => {
  const goBack = useGoBack();

  const location = useLocation()

  const { data: company } = useMineCompany();

  const route = useMemo(() => {
    const firstPath = location?.pathname?.split('/')?.[1] || ''

    if (firstPath)
      return flattedRoutes({ company }).find(({ path }) => path === `/${firstPath}`)

    return {
      path: '/company',
      label: 'Dados gerais',
    }
  }, [location?.pathname])

  return (
    <div className={twMerge('flex w-full flex-col items-center gap-3 h-screen overflow-auto', className)} data-testid="not_found_error_message">
      <div className="mt-auto">
        <img src="/cloud.gif" className="shrink-0 w-[305px]" />
      </div>

      <div className="flex flex-col items-center -mt-16 mb-auto p-8">
        <p className="text-sm font-bold">
          Ops! Não tem nada por aqui...
        </p>

        <p className="text-xs mt-2">
          O recurso que você está procurando não foi encontrado.
        </p>

        {!hideButton && (
          <Button onClick={() => goBack({ fallback: fallback || route?.path as string || '/company', searchLastRouteFromFallback: true })} className="mt-4">
            {buttonText || `Ir para ${route?.label || 'Dados gerais'}`}
          </Button>
        )}
      </div>
    </div>
  )
}

export const NotFoundPage = () => <NotFoundErrorMessage className='h-[calc(100vh-64px)]' />
